import axiosInstance, { ADMIN_BASEURL } from './axiosInstance';


const useServices = () => {
    const GenerateHeaders = () => {
        const token = "accesstoken"
        var headers = {
            "headers": {
                "Authorization": `Bearer ${token}`
            }
        }
        return headers
    }
    const get = async (endpoint,cancelToken) => {
        try {
            //const headers = GenerateHeaders()

            const response = await axiosInstance.get(endpoint, {
                cancelToken: cancelToken, // <-- 2nd step
              }); // Add header variable for authentication
            return response
        } catch (error) {
            ServiceErrorHandling(error)
            throw error
        }

    }
    const getValidateAccount = async (endpoint) => {
        try {
            //const headers = GenerateHeaders()

            const response = await axiosInstance({url : endpoint, baseURL : ADMIN_BASEURL}); // Add header variable for authentication
            return response
        } catch (error) {
            ServiceErrorHandling(error)
            throw error
        }

    }
    const post = async (endpoint, requestBody) => {
        try {
            //const headers = GenerateHeaders()
            const response = await axiosInstance.post(endpoint, requestBody); //Add header variable for auth
            return response

        } catch (error) {
            ServiceErrorHandling(error)
            throw error
        }

    }
    const put = async (endpoint, requestBody) => {
        try {
            const headers = GenerateHeaders()
            const response = await axiosInstance.put(endpoint, requestBody, headers);
            return response

        } catch (error) {
            ServiceErrorHandling(error)
            throw error
        }

    }
    const deleteService = async (endpoint, requestBody) => {
        try {
            const headers = GenerateHeaders()
            const response = await axiosInstance.delete(endpoint, headers);
            return response

        } catch (error) {
            ServiceErrorHandling(error)
            throw error
        }

    }
    const ServiceErrorHandling = (err) => {
        if (err.response) {
            // client received an error response (5xx, 4xx)
            if (err.response.status === 401) {
                // if unauthorized user then redirect to login page or do silent login to 
                // generate accesstoken using refreshtokens
            }
        } else if (err.request) {
        } else {

        }
    }


    return { get, post, put, deleteService, getValidateAccount }



}
export default useServices